var finansudd = finansudd || {};

finansudd.employeelist = new function () {

	var self = this;
	
	this.initEmployees = function () {
		if ($("#employees-list").length) {
			self.loadEmployees();
			self.getFilter();
		}
	}

	this.getFilter = function () {
		var filters = $(".employee-filter");

		filters.on('change', function () {
			self.loadEmployees();
		});
	}
	
	this.loadEmployees = function () {

		var subjectAreas = [];
		var departments = [];
		var getSubjectAreaValues = $("#filterid-3130").val();
		var getDepartmentsValues = $("#filterid-3129").val();

		if (getSubjectAreaValues!=null)
		{
			subjectAreas = getSubjectAreaValues;
		}
        
		if (subjectAreas == null || subjectAreas == undefined || subjectAreas == "0") {
			subjectAreas = [];
		}

		if (getDepartmentsValues != null) {
			departments = getDepartmentsValues;
		}

		if (departments == null || departments == undefined || departments == "0") {
			departments = [];
		}

		var filterValues = JSON.stringify({
			"SubjectAreas": subjectAreas,
			"Departments": departments
		});

	    $("#filterEmployeeName").val("");

		$.ajax({
			url: "/settings/employeelistview/",
			type: 'POST',
			cache: false,
			contentType: "html/text; charset=utf-8",
			dataType: 'html',
			data: filterValues,
			success: function(data) {

				$("#employees-list").html(data);
				novicell.responsiveImages.init();
			},
			error: function (data, errorThrown) {
				$("#employees-list").html('<div class="ajax-content error-msg">Der er desværre sket en fejl </br></br> <button class="btn btn-blue light" onclick="location.reload();"> Genindlæs siden </button></div>');

			    console.log(errorThrown);
			}
		});
	}
}